import {Stack} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {dibAdminApi} from "../../dibAdminApi/dibAdminApi";
import {NavItem} from "../../components/NavItem";
import IconChevronRight from "../../assets/chevron-right.svg?react";
import {useNewsFilters} from "./useNewsFilters";
import {useNewsGroupings} from "./useNewsGroupings";
import layoutClasses from "./DashboardView.module.css";
import classes from "./NewsFilterSidebar.module.css";

/**
 * Desktop-only sidebar for the News tab: multi-select portal-grouping and
 * source filters, occupying the same layout slot as the portals groupings
 * sidebar. Filter state lives in URL search params (see useNewsFilters).
 */
export function NewsFilterSidebar() {
    const {t} = useTranslation();
    const groupings = useNewsGroupings();
    const {sources, toggleValue, clear} = useNewsFilters();
    const {data: allSources = []} =
        dibAdminApi.endpoints.getNewsSources.useQuery({});

    return (
        <Stack
            miw={200}
            maw={250}
            gap={0}
            w="100%"
            className={layoutClasses.sidebar}
        >
            <div className={classes.group}>
                <NavItem
                    onClick={groupings.clear}
                    active={groupings.selectedSlugs.length === 0}
                    rightSection={
                        groupings.selectedSlugs.length === 0 && (
                            <IconChevronRight />
                        )
                    }
                >
                    {t("News.allAreas", {defaultValue: "All areas"})}
                </NavItem>
                {groupings.options.map((option) => (
                    <NavItem
                        key={option.slug}
                        onClick={() => groupings.toggle(option.slug)}
                        active={groupings.selectedSlugs.includes(option.slug)}
                        rightSection={
                            groupings.selectedSlugs.includes(option.slug) && (
                                <IconChevronRight />
                            )
                        }
                    >
                        {option.name}
                    </NavItem>
                ))}
            </div>
            <div className={classes.group}>
                <NavItem
                    onClick={() => clear("sources")}
                    active={sources.length === 0}
                    rightSection={sources.length === 0 && <IconChevronRight />}
                >
                    {t("News.allSources", {defaultValue: "All sources"})}
                </NavItem>
                {allSources.map((source) => (
                    <NavItem
                        key={source}
                        onClick={() => toggleValue("sources", source)}
                        active={sources.includes(source)}
                        rightSection={
                            sources.includes(source) && <IconChevronRight />
                        }
                    >
                        {source}
                    </NavItem>
                ))}
            </div>
        </Stack>
    );
}
